export default __webpack_public_path__ + "9b952c438a2413bae853cea85e65080a.png";